export class FatalError extends Error {}
